import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'
import Swiper from 'swiper'

class  Slider extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)

    this.ref = {
      container: null
    }

  }


  mount() {
    console.log("Mount Slider!");

    this.resizeQue = this.resize.bind(this)
    stage.on("stage:resize", this.resizeQue);
    // this.renderQue = this.render.bind(this)
    // stage.on("stage:scroll", this.renderQue);
    this.resize(stage);



  }


  createSlider(){

    let tolerance =  0.07
    console.log(this.ref.container);
    this.swiperInstance = new Swiper (this.ref.container, {
        loop: false,
        spaceBetween : 10,
        slidesPerView: 'auto',
        slidesOffsetBefore: 30,
        slidesOffsetAfter: 30,
        watchSlidesProgress: true,
        pagination: {
            el: '.swiper-pagination',
        },
        breakpointsInverse: true,
        breakpoints: {
            768: {
                slidesPerView: 'auto',
                spaceBetween: 30,
                slidesOffsetAfter: 30,
                centeredSlides : true
            }
        }
        ,
        on: {
            progress: function(){
                let swiper = this;
                for (let i = 0; i < swiper.slides.length; i++) {
                let slideProgress = swiper.slides[i].progress,
                    innerOffset = swiper.width * tolerance,
                    innerTranslate = slideProgress * innerOffset;

                    swiper.slides[i].querySelector('img').style.transform = 'translateX(' + innerTranslate  + 'px)';
                }
            },
            touchStart: function() {
                let swiper = this;
                for (let i = 0; i < swiper.slides.length; i++) {
                swiper.slides[i].style.transition = ''
                }
            },
            setTransition: function(speed) {
                let swiper = this;
                for (let i = 0; i < swiper.slides.length; i++) {
                swiper.slides[i].style.transition = speed + "ms"
                swiper.slides[i].querySelector("img").style.transition =
                    speed + "ms"
                }
            },
            beforeDestroy : function() {
                let swiper = this;
                for (let i = 0; i < swiper.slides.length; i++) {
                    swiper.slides[i].querySelector('img').style.transform = null
                }
            }
        }
    })
  }

  unmount() {
    console.log("Unmount Slider!");

    stage.removeAllListeners();

    if(this.swiperInstance) {
      this.swiperInstance && this.swiperInstance.destroy()
      this.swiperInstance = null
    }
  }


  resize(e){

    this.h = e.h/2
    this.element.dataset.top = this.el.offset().top


    if(e.w < 1024 ) {

      if(!this.swiperInstance){
        this.createSlider()
      }

    }
    else {
      this.swiperInstance && this.swiperInstance.destroy()
      this.swiperInstance = null
    }

    this.render(stage)

  }

  renderQueCall(){

  }

  render(e){


  }


}

module.exports = Slider
